import { Inject, Injectable } from 'ng-metadata/core';
import { UserSessionManagerService } from '../../security/userSessionManager.service';
import { getVid } from '../../appConfig/appConfigForward';
import { SharedSessionStorage } from '../../infra/sharedSessionStorage.service';

@Injectable()
export class AdvancedSearchService {

	private ADVANCED_SEARCH_MODE = 'advancedSearchMode'; //SessionStorage key
    private vid = getVid();
    private personalDetailsRestUrl: string;

	

    constructor(private sharedSessionStorage: SharedSessionStorage,
        private userSessionManagerService: UserSessionManagerService,
		@Inject('$http') private $http: ng.IHttpService,
		@Inject('restBaseURLs') private restBaseURLs) {
		this.$http = $http;
		this.personalDetailsRestUrl = restBaseURLs.userSettingsBaseURL;
	}

    public setSessionAdvancedSearchMode(value: string){
        this.sharedSessionStorage.setItem(this.ADVANCED_SEARCH_MODE, value);
    }

    public getSessionAdvancedSearchMode(): string {
       return this.sharedSessionStorage.getItem(this.ADVANCED_SEARCH_MODE);
    }

    public removeSessionAdvancedSearchMode() {
        this.sharedSessionStorage.removeItem(this.ADVANCED_SEARCH_MODE);
    }

    /*
    returns true if the user is logged in
    */
    public isLoggedIn(){
        return this.userSessionManagerService.getUserName() && this.userSessionManagerService.getUserName().length > 0;
    }

    /*
    Update user selection in DB
     */
    public saveUserSelectionToDB(selection: string) {  //saving the user's selection to DB, so we'll have it both in SessionStorage & DB
		let updateUserAdvancedModeSelectionPromise = this.updateUserAdvancedModeSelection(selection);
		updateUserAdvancedModeSelectionPromise.then(
            (response) => {},
			(error) => {
				console.error("Advanced Search mode - save to DB failed");
			}
		);
	}

    private updateUserAdvancedModeSelection(selection) { //POST to DB
		let payload = this.buildPayload(selection);
		return this.$http.post(this.personalDetailsRestUrl, payload);
	}

	private buildPayload(value) {   //value to insert the DB, should be: collapsed OR expanded
		let payload =  {
            'vid': this.vid,
			'advanced_mode': value      //DB key
        }
		return payload;
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/advancedSearch.service.ts